module.exports = __webpack_public_path__ + "media/images/flags/16/Dominica-fd5ab03edcd6edf089cefa66fb76c685.png";